import { SPELLSLINGER_RULES } from './spellslinger';
import { PATHFINDER_RULES } from './pathfinder';
import { MAGICIAN_RULES } from './magician';
import { DUPLICATOR_RULES } from './duplicator';
import { IMPOSTER_RULES } from './imposter';
import { SORCERER_RULES } from './sorcerer';
import { REALM_EATER_RULES } from './realmEater';
import { GEOMANCER_RULES } from './geomancer';
import { ANIMIST_RULES } from './animist';
import { HARBINGER_RULES } from './harbinger';
import { DRUID_RULES } from './druid';
import { ENCHANTRESS_RULES } from './enchantress';
import { ARCHIMAGO_RULES } from './archimago';
import { DRAGONLORD_RULES } from './dragonlord';

/**
 * Map from an avatar card's `cardId` (the catalog-level identifier, e.g.
 * `sorcery-spellslinger`, same format produced by `normalizeCards.js`)
 * to its rule overrides.
 *
 * Adding a new avatar:
 *   1. Create `./<avatar-name>.js` exporting a partial AvatarRules object.
 *   2. Import and register here keyed by `sorcery-<kebab-name>`.
 *   3. Done. The resolver deep-merges automatically.
 *
 * Avatars whose entire rule set is the default (Sorcerer, Battlemage,
 * etc.) don't need an entry here at all. Only list avatars that
 * actually modify something.
 */
export const AVATAR_RULES_REGISTRY = {
  'sorcery-spellslinger': SPELLSLINGER_RULES,
  'sorcery-pathfinder':   PATHFINDER_RULES,
  'sorcery-magician':     MAGICIAN_RULES,
  'sorcery-duplicator':   DUPLICATOR_RULES,
  'sorcery-imposter':     IMPOSTER_RULES,
  'sorcery-sorcerer':     SORCERER_RULES,
  'sorcery-realm_eater':  REALM_EATER_RULES,
  'sorcery-geomancer':    GEOMANCER_RULES,
  'sorcery-animist':      ANIMIST_RULES,
  'sorcery-harbinger':    HARBINGER_RULES,
  'sorcery-druid':        DRUID_RULES,
  'sorcery-enchantress':  ENCHANTRESS_RULES,
  'sorcery-archimago':    ARCHIMAGO_RULES,
  'sorcery-dragonlord':   DRAGONLORD_RULES,
  // Deathspeaker is deliberately NOT registered here: "The copy
  // enters the realm, uses its Genesis, then is banished" is only
  // honest once every Genesis ability is automated. Today most
  // minions' Genesis text would silently no-op and the copy would
  // banish having done nothing. Its rules live in
  // engine/automation/ops/deathspeaker.js.
};
